/* eslint import/prefer-default-export: 0 */
import { ICON, RESOURCE_TYPE } from './CONSTANTS';

import TettraQuestion from '../schemas/TettraQuestionSchema';
import NotionPage from '../schemas/NotionPageSchema';

const RESOURCE_MAP = {
    [RESOURCE_TYPE.TETTRA_QUESTION]: TettraQuestion,
    [RESOURCE_TYPE.NOTION_PAGE]: NotionPage,
};

const getResourceFromEntityData = (entityData) => {
    const Resource = RESOURCE_MAP[entityData.referenceType];

    return Resource.FromEntityData(entityData);
};

/**
 * Handles these scenarios (all return 94312)
 *
 * "App\Models\Page::94312::99"
 * "App\Models\Page::94312"
 * "App\Models\Question::94312"
 * "page_94312" // model_id
 * "document_9_94312" //"model_part_id"
 */
const getIndexResourceId = (objectId) => {
    if (typeof objectId === 'number') return objectId;

    if (objectId.includes('::')) {
        return parseInt(objectId.toString().split('::')[1], 10);
    }

    return parseInt(objectId.toString().split('_').pop(), 10);
};

const getResourceTypeFromCommentableType = (commentableType) => {
    switch (commentableType) {
    case 'App\\Models\\Question':
        return ICON.COMMENT_SUGGESTION;
    case 'App\\Models\\Suggestion':
        return ICON.COMMENT_QUESTION;
    default:
        return ICON.COMMENT_PAGE;
    }
};

const getResourceTypeFromModel = (model, commentable_type = null) => {
    switch (model) {
    case 'App\\Models\\Page':
        return RESOURCE_TYPE.TETTRA_PAGE;
    case 'App\\Models\\Question':
        return RESOURCE_TYPE.TETTRA_QUESTION;
    case 'App\\Models\\Document':
        return RESOURCE_TYPE.TETTRA_PDF;
    case 'App\\Models\\Category':
        return RESOURCE_TYPE.TETTRA_CATEGORY;
    case 'App\\Models\\Folder':
        return RESOURCE_TYPE.TETTRA_FOLDER;
    case 'App\\Models\\Comment':
        return getResourceTypeFromCommentableType(commentable_type);
    default:
        return '';
    }
};

export { getResourceFromEntityData, getIndexResourceId, getResourceTypeFromModel };
